import { formatEther, formatPercent, isNull, Maybe, numberToFixed } from '@/utils/common';
import { BigNumber, ethers } from 'ethers';
import { Shimmer } from './Shimmer';
import { Tooltip } from './Tooltip';

type TokenUnitProps = {
    value?: BigNumber;
    formattedValue?: Maybe<string>;
    symbol?: string;
    isFiat?: boolean;
    precision?: number;
    formatPercentage?: boolean;
    isLoading?: boolean;
};

export const TokenUnit = ({
    value,
    symbol,
    isFiat = false,
    precision,
    formatPercentage,
    formattedValue,
    isLoading = false,
}: TokenUnitProps) => {
    const isDisabled = isNull(value) || formatPercentage;
    const format = () => {
        if (!!precision) return precision;
        if (value?.gt(ethers.utils.parseEther('0.01'))) {
            return 2;
        } else if (value?.gt(ethers.utils.parseEther('0.0001'))) {
            return 4;
        } else if (value?.gt(ethers.utils.parseEther('0.000001'))) {
            return 6;
        } else {
            return 2;
        }
    };
    const _precision = format();

    return (
        <Tooltip title={value ? formatEther(value) : undefined} disabled={isDisabled} arrowSize="small">
            <Shimmer height={20} width={96} isLoading={isLoading!}>
                <span className="cursor-default">
                    {isFiat && '$'}
                    {formattedValue && formattedValue}
                    {value && (formatPercentage ? formatPercent(value) : numberToFixed(value, _precision, true))}{' '}
                    {symbol && symbol}
                </span>
            </Shimmer>
        </Tooltip>
    );
};
